// Runs `tick` every `periodMs` while the page is visible. A tick that falls due while the tab is
// hidden is held and runs once when the tab is shown again, so a returning user sees fresh values
// without a background tab polling the API for the life of the session.
// Returns a stop function that clears the timer and the listener.
// The default timers call the globals unbound: a browser throws "Illegal invocation" when a Window
// timer runs with another object as `this`, as it would from `{ setInterval }.setInterval(...)`.
const globalTimers = {
  setInterval: (fn, ms) => setInterval(fn, ms),
  clearInterval: (id) => clearInterval(id),
};

export const startVisibleInterval = (
  tick,
  periodMs,
  { doc = document, timers = globalTimers } = {},
) => {
  let missedWhileHidden = false;

  const onTick = () => {
    if (doc.visibilityState === 'hidden') {
      missedWhileHidden = true;
      return;
    }
    tick();
  };

  const onVisibilityChange = () => {
    if (doc.visibilityState !== 'hidden' && missedWhileHidden) {
      missedWhileHidden = false;
      tick();
    }
  };

  const id = timers.setInterval(onTick, periodMs);
  doc.addEventListener('visibilitychange', onVisibilityChange);

  return () => {
    timers.clearInterval(id);
    doc.removeEventListener('visibilitychange', onVisibilityChange);
  };
};

export default startVisibleInterval;
